import pluralize from 'pluralize'

const menuItemsSelector = (state, menuItems) => {
  let processedItems = []

  for (const k in menuItems) {
    if (menuItems.hasOwnProperty(k)) {
      const menuItem = menuItems[k]
      const type = pluralize(menuItem.menuableType)
      const id = menuItem.menuableId

      const item = state[type][id]
      menuItem.item = item

      processedItems.push(menuItem)
    }
  }

  return processedItems
}

export default menuItemsSelector



// WEBPACK FOOTER //
// ./src/selectors/menuItems.js